import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { BaseFieldComponent } from '../base-field.component';

@Component({
    selector: 'app-time-field',
    imports: [IonicModule],
    template: `
        @if (readonly) {
            <ion-item lines="none">
                <ion-label>
                    <p class="field-label">{{ field.label }}</p>
                    <p class="field-value">{{ formatTime(value) }}</p>
                </ion-label>
            </ion-item>
        } @else {
            <ion-item>
                <ion-label position="stacked">{{ field.label }}</ion-label>
                <ion-input
                    type="time"
                    [value]="value"
                    [required]="isRequired"
                    (ionChange)="onTimeChange($event)">
                </ion-input>
            </ion-item>
            @if (field.helpText) {
                <ion-note class="field-help">{{ field.helpText }}</ion-note>
            }
        }
    `,
    styles: [`
        .field-help {
            padding: 4px 16px;
            font-size: 12px;
        }
        .field-label {
            color: var(--ion-color-medium);
            font-size: var(--fs-400);
        }
        .field-value {
            white-space: pre-wrap;
            font-size: var(--fs-400);
        }
    `]
})
export class TimeFieldComponent extends BaseFieldComponent {
    initialize(value: any): void {
        this.value = value ?? '';
    }

    serialize(): any {
        return this.value;
    }

    /**
     * Handle time change from ion-input.
     * Uses ionChange instead of ionInput to support native mobile time pickers,
     * which don't fire ionInput events when selecting from the picker UI.
     */
    onTimeChange(event: any): void {
        const newValue = event.detail.value ?? '';
        this.emitChange(newValue);
    }

    formatTime(value: string): string {
        if (!value) return '-';
        // Show HH:mm format, strip seconds if present
        return value.substring(0, 5);
    }
}
